// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"cf8da25d","3919":"99954768","5079":"cf8da25d","7876":"cf8da25d","9990":"19791745"}[chunkId] + ".chunk.css";
};